export const MONTHS = [
	{
			value: 1,
			label: window.gettext("01 (Jan)"),
	},
	{
			value: 2,
			label: window.gettext("02 (Feb)"),
	},
	{
			value: 3,
			label: window.gettext("03 (Mar)"),
	},
	{
			value: 4,
			label: window.gettext("04 (Apr)"),
	},
	{
			value: 5,
			label: window.gettext("05 (May)"),
	},
	{
			value: 6,
			label: window.gettext("06 (Jun)"),
	},
	{
			value: 7,
			label: window.gettext("07 (Jul)"),
	},
	{
			value: 8,
			label: window.gettext("08 (Aug)"),
	},
	{
			value: 9,
			label: window.gettext("09 (Sep)"),
	},
	{
			value: 10,
			label: window.gettext("10 (Oct)"),
	},
	{
			value: 11,
			label: window.gettext("11 (Nov)"),
	},
	{
			value: 12,
			label: window.gettext("12 (Dec)"),
	}
];

const currentYear = new Date().getFullYear();
export const YEARS = Array.from(new Array(20), (_, index) => ({
  value: index + currentYear,
  label: `${index + currentYear}`
}));
